import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/login-settings'),
      component: SettingsContent,
      props: {
        headerTitle: 'Login Setting',
        icon: 'lock-shield',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_login_setting',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
